<template>
  <div id="fh5co-wrapper">
  <div id="fh5co-page">
  <Header></Header>
  <div id="fh5co-team-section" class="fh5co-lightgray-section">
    <div class="container">
      <div class="heading-section text-center animate-box">
        <h2>個人情報保護方針</h2>
      </div>
      <div class="privacy-container">
        <div>
          <h2>1.当社は個人の権利・利益を尊重します。</h2>
          <p>個人情報に関する個人の権利・利益を尊重し、自己の個人情報に対し、開示・訂正・削除を求められたときは、合理的な期間内に、妥当な期間内で、これに応じます。</p>
          <h2>2.当社は、適切な個人情報の収集、利用および提供に努めます。</h2>
          <p>お客さまから個人情報を直接収集する場合は、収集目的を当社の正当な事業範囲内で明確に定め、その目的達成のために必要な限度において、公正且つ適正な方法で個人情報の収集、利用、および提供を行ないます。また、目的外利用を禁止し、防止する措置を講じます。 業務受託で得意先から預かる個人情報に関しては、得意先と当社の間で、機密保持、授受、保管、返却、廃棄等について契約書、ルールを定め、お預かりした個人情報の厳格な管理を致します。 個人情報を外部へ委託する場合の措置に関しては、委託会社と当社の間で、機密保持、授受、保管、返却、廃棄等、についてルールを定め、契約書を締結の上、厳正な管理を行います。</p>
          <h2>3.当社は個人情報の適正な管理を行います。</h2>
          <p>一時的、恒常的を問わず、当社で保有する個人情報に対する、不当な改ざん、紛失、漏えいが発生せぬよう、また、不必要、不適切なアクセスが行われないよう、組織、技術、社員教育等、予防及び是正に努め、あらゆる面から、個人情報の適正管理を行うことができる信頼性のある環境を作り上げます。</p>
          <h2>4.当社は法令、その他の規範を遵守します。</h2>
          <p>個人情報に関する法令・条例および社内規定の定めを遵守し、社会的責任を果たします。</p>
          <h2>5.苦情及び相談について対応します。</h2>
          <p>個人情報の取扱いについての苦情及び相談の窓口の設置及び責任者を任命し、速やかに対応します。</p>
          <h2>6.個人情報の収集と利用目的について</h2>
          <p>当社では、下記のサービス提供のために、個人情報を利用しております。なお、個人情報とは入力フォームを通して、ご登録者の氏名・住所・電話番号・Eメールアドレス、によりご登録者個人を識別できるものを指します。</p>
          <ol>
            <li>ご登録者の承諾に基づいた個人情報開示</li>
            <li>個人識別して提供するサービスの提供</li>
          </ol>
          <h2>7.情報の提供について</h2>
          <p>当社では、次の場合を除いて、ご登録者を特定する情報を外部に提供することはありません。</p>
          <ol>
            <li>ご登録者様が同意されている場合</li>
            <li>ご登録者様または公共の利益のために必要で有ると考えられる場合</li>
            <li>事業協力会社や顧問契約締結先(弁護士等)に提供する場合</li>
          </ol>
          <h2>8.個人情報の管理方法について</h2>
          <p>収集した個人情報は厳正な管理の下で安全に蓄積・保管します。 セキュリティに関して 収集した個人情報は、適切な管理のもとで安全に保管し、不正アクセス、紛失、破壊、改竄、漏洩等から保護するため、コンピュータシステム上の安全対策など各種の措置を講じていきます。</p>
          <h2>9.個人情報の開示・訂正・削除について</h2>
          <p>ご自身に関する個人情報について開示を請求することができます。また、その結果、必要な場合は訂正、追加、削除を求めることができます。その他、個人情報の利用停止・第三者への提供の停止や苦情・相談など申し付けることができます。これらを受付けた場合、合理的な範囲内で適切に対応させていただきます。また、その際は、本人確認をさせて頂く場合があります。個人情報の開示・訂正・削除を請求される場合は、下記のお問合せ窓口までお申し出ください。</p>
          <h2>10.お問合せ窓口</h2>
          <p><a href="mailto:taku-gym@legame-online.com" target="_blank">こちら</a>よりお問合せください。</p>
          <p>開示、訂正、削除のご請求、その他ご不明な点についてのお問合せは、上記までご連絡いただきますようお願いします。ご本人であることを確認させていただいた上で、上記各条件に従い、ご登録者様のご依頼に対応させていただきます。</p>
        </div>
      </div>
    </div>
  </div>
  <Footer></Footer>
</div>
</div>
</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'

export default {
  name: 'Privacy',
  components: {
    Header,
    Footer
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.privacy-container{
  background-color: #fff;
  padding: 20px;
}
.privacy-container h2{
  font-size: 20px;
  font-weight: bold;
  border-bottom: 3px #cdff19 solid;
  margin-bottom: 5px;
  padding-bottom: 5px;
  padding-top: 20px;
}
.privacy-container p{
  font-size: 18px;
}

</style>



// WEBPACK FOOTER //
// src/components/Privacy.vue